import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white letter-spacing" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = {
  key: 0,
  class: "badge text-bg-warning fs-13 me-5 mt-10"
}
const _hoisted_6 = {
  key: 1,
  class: "badge text-bg-info fs-13 me-5 mt-10"
}
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: 4 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_center = _resolveComponent("center")!
  const _component_vue_good_table = _resolveComponent("vue-good-table")!
  const _component_PaginatorContent = _resolveComponent("PaginatorContent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _cache[1] || (_cache[1] = _createElementVNode("div", { class: "card-head box-shadow bg-white d-lg-flex align-items-center justify-content-between p-15 p-sm-20 p-md-25" }, [
      _createElementVNode("div", { class: "d-flex align-items-center" }, [
        _createElementVNode("input", {
          type: "text",
          class: "form-control shadow-none text-black rounded-0",
          placeholder: "Search "
        })
      ])
    ], -1)),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_vue_good_table, {
        columns: _ctx.headers,
        rows: _ctx.rows
      }, {
        emptystate: _withCtx(() => [
          _createVNode(_component_center, null, {
            default: _withCtx(() => _cache[0] || (_cache[0] = [
              _createTextVNode("Aucune entrées correspondantes trouvées", -1)
            ])),
            _: 1,
            __: [0]
          })
        ]),
        "table-row": _withCtx((props) => [
          (props.column.field == 'created_at')
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.getDate(props.row.created_at)), 1))
            : (props.column.field === 'type')
              ? (_openBlock(), _createElementBlock("span", _hoisted_4, [
                  (props.row.type == 'SIMPLE_PARCEL')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, " Colis Simple "))
                    : _createCommentVNode("", true),
                  (props.row.type == 'SIMPLE_STOCK')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_6, " Colis de stock "))
                    : _createCommentVNode("", true)
                ]))
              : (props.column.field === 'statut')
                ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                    _createElementVNode("div", {
                      class: _normalizeClass([`fs-13 me-5 mt-10 badge text-bg-${_ctx.resolveUStatus(0)}`, "text-capitalize"])
                    }, _toDisplayString(props.row.statut), 3)
                  ]))
                : (props.column.field === 'customer')
                  ? (_openBlock(), _createElementBlock("span", _hoisted_8, [
                      (props.row.client?.store)
                        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                            _createTextVNode(_toDisplayString(props.row.client.store), 1)
                          ], 64))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(props.formattedRow[props.column.field]), 1))
        ]),
        _: 1
      }, 8, ["columns", "rows"]),
      _createVNode(_component_PaginatorContent, {
        pagination: _ctx.users,
        offset: 9,
        onPaginate: _ctx.fetchData
      }, null, 8, ["pagination", "onPaginate"])
    ])
  ]))
}